const transitionDurationMs = 250;
const wrapper = "_275w1p7siix";
const contentWrapper = "_275c9kamlr";
const content = "_275c1tj9dtt";
const tabListTitle = "_275t1o7k2z1";
const searchWrapper = "_275s1gw7w7o";
const tabToggleNotificationBadge = "_275tub7ukr";

export { content, contentWrapper, searchWrapper, tabListTitle, tabToggleNotificationBadge, transitionDurationMs, wrapper };
import "./shared.tablist.style.linaria.module.css";
//# sourceMappingURL=shared.tablist.style.js.map
